import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getPublicNeighborhoodOptions, type PublicOptionResponse } from "./publicOptions.api";

interface UseGetNeighborhoodOptionsReturn {
  neighborhoodOptions: PublicOptionResponse[];
  fetchNeighborhoodOptions: () => Promise<void>;
}

export const useGetNeighborhoodOptions = (organizationId?: string): UseGetNeighborhoodOptionsReturn => {
  const [neighborhoodOptions, setNeighborhoodOptions] = useState<PublicOptionResponse[]>([]);
  const { run: runLatestRequest } = useLatestRequest();

  const fetchNeighborhoodOptions = useCallback(async () => {
    try {
      if (!organizationId) return;
      const response = await runLatestRequest((signal) =>
        getPublicNeighborhoodOptions(organizationId, signal),
      );
      if (!response) return;
      setNeighborhoodOptions(response);
    } catch (error) {
      console.error("Failed to fetch neighborhood options:", error);
    }
  }, [organizationId, runLatestRequest]);

  return {
    neighborhoodOptions,
    fetchNeighborhoodOptions,
  };
};
